import React, { useState, useEffect } from "react";
import Quote from "@system/config/quote";
import System from "../../../helper/system";
import Constants from "../../../helper/Constants";
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import { useBOMStore } from "src/hooks/bom";
import { useProductInventoryPriceStore } from "src/hooks/productInventoryPrice";
import { useCartStore } from "src/hooks/cart";
import { useSystem } from "src/hooks/system";

const AddedPartQuotePopup = (props) => {
    const { data, SetStatus } = props;
    const { quoteDetail, single_product } = data?.data;
    const [{ bom_detail_by_bom_id, bom_detail_by_bom_id_type, bom_project_list }] = useBOMStore();
    const [{ }, { get_inventory_by_id, get_pricing_by_id }, { }] = useProductInventoryPriceStore();
    const [{ CART_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [loader, setLoader] = useState(false);
    const [,{ get_quantity_format }] = useSystem();

    const onHide = () => {
        SetStatus(false)
    };

    useEffect(() => {
        if (quoteDetail) {
            SetStatus(true)
            addQuoteEvent();
        }
    }, [quoteDetail]);

    //By Ramya Kannan [Add to quote - Adobe script ]
    function addQuoteEvent() {
        let isBOM = quoteDetail?.addFrom;
        let eventType;
        if (isBOM === "BOM") {
            eventType = "addToQuoteFromBOM";
        } else {
            eventType = "addToQuote";
        }
        localStorage.setItem("adobeEventType", eventType);
        let copyProd = single_product;
        let prodDetails = { ...copyProd };
        if (Array.isArray(prodDetails)) {
            prodDetails[0].quantity = quoteDetail?.quantity1;
        } else {
            prodDetails.quantity = quoteDetail?.quantity1;
        }

        let getBomDetails = bom_detail_by_bom_id;
        let bomDetails = { ...getBomDetails };
        if (bom_project_list) {
            bomDetails.projectName = bom_project_list[bom_detail_by_bom_id.projectId]?.projectName
        }
        bomDetails.exactMatchCount = bom_detail_by_bom_id_type?.Exact?.count;
        bomDetails.nomatchCount = bom_detail_by_bom_id_type?.NoMatch?.count;
        bomDetails.multipleMatchCount = bom_detail_by_bom_id_type?.Multiple?.count;
        prodDetails.qas = get_inventory_by_id(prodDetails.ItemNumber)?.inventoryQty || 0;
        let pricingDetails = getPricing(prodDetails);
        prodDetails.priceSource = pricingDetails?.priceSource;
        prodDetails.unitPrice = pricingDetails?.marketPrice;
        prodDetails.subtotal = prodDetails?.subtotal || (pricingDetails?.marketPrice * CART_BEFORE_TO_SEND_SERVER[prodDetails?.ItemNumber].quantityUpdateToCart);
        let cartDetails = {
            "cartType": "Quote",
            "additionSource": quoteDetail?.addFrom,
            "quoteID": quoteDetail?.quoteLineItemId,
            "quoteType": "online"

        }
        if (Object.keys(prodDetails).length) {
            HelperAdobeEvent.trackingAdobeEvent({ prodDetails, cartDetails, bomDetails });
        }
    }

    const getPricing = (ele) => {
        let priceValues = get_pricing_by_id({ uniqueId: ele.bomDetailId ? ele.bomDetailId : ele.ItemNumber })
        return priceValues && priceValues[0];
    }

    return (
        <>
            <div className="avnet-modal modal-600">
                <div className="avnet-modal-inner">
                    <button type="button" className="close" data-dismiss="modal"
                        onClick={() => {
                            onHide()
                        }}>×</button>
                    <div className="modal-header border-0">
                        <h3 className="modal-title m-auto" id="exampleModalLabel">Request a Quote</h3>
                    </div>
                    <div className="modal-body">
                        {quoteDetail && Object.keys(quoteDetail).length > 0 &&
                            <>
                                <div className="alert alert-success alert-dismissible m-b-5">
                                    <span>You've added a part to your open quote.</span>
                                    <a href={void (0)} className="close" data-dismiss="alert" aria-label="close">&times;</a>
                                </div>
                                <div className='m-b-10'>
                                    <b>Quote Number: </b> Open
                                </div>
                                <table className="table border-1">
                                    <thead>
                                        <tr className='bg-grey2'>
                                            <th>Part Number/Manufacturer  </th>
                                            <th>Quote Qty</th>
                                            <th>Target Unit Price</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {quoteDetail.quantity1 && quoteDetail.quantity1 > 0 &&
                                            <tr>
                                                <td className="border-0" rowSpan="3">{single_product?.ERPMFRPartNumber} <br />
                                                    By {single_product?.ManufacturerName}</td>
                                                <td className="border-0">{get_quantity_format(quoteDetail.quantity1)} </td>
                                                <td className="border-0">{quoteDetail.targetUnitPrice ? System.getFormatNumber({
                                                    amount: Number(quoteDetail.targetUnitPrice),
                                                    isDisplaySymbol: false,
                                                    currency: Constants.currencyType.USD,
                                                }) : Constants.noValue}</td>
                                            </tr>
                                        }
                                        <tr>
                                            <td className="border-0">{quoteDetail.quantity2 && quoteDetail.quantity2 > 0 ? get_quantity_format(quoteDetail.quantity2) : '——'} </td>
                                            <td className="border-0">{'——'}</td>
                                        </tr>

                                        <tr>
                                            <td className="border-0">{quoteDetail.quantity3 && quoteDetail.quantity3 > 0 ? get_quantity_format(quoteDetail.quantity3) : '——'} </td>
                                            <td className="border-0">{'——'}</td>
                                        </tr>

                                    </tbody>
                                </table>
                                <div className="text-center quote-popup-text">
                                    <b className="d-block">You're almost done!</b>
                                    Click "<b>Review Quote</b>" to go to "My Open Quotes" to complete submitting this
                                    part for a quotation response. If you continue shopping you can always go to "My Open Quotes" in your Dashboard to complete submitting this part.
                                </div>
                            </>
                        }

                    </div>
                    <div className="modal-footer d-flex justify-content-center">
                        <button type="button" className="bs5 btn btn-secondary" disabled={loader}
                            onClick={onHide}>Continue Shopping</button>
                        <button type="button" className="bs5 btn btn-primary w145"
                                disabled={loader}
                            onClick={() => {
                                setLoader(true);
                                window.location.href = Quote.getQuoteRouteURL()
                            }}>{loader ? <i className="fa fa-spinner fa-spin"/> : "Review Quote"}</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddedPartQuotePopup;